import { defineMessages } from 'react-intl';

export default defineMessages({
  edit: {
    id: 'CartV2.lineItem.edit',
    description: 'Message for the edit link in line items',
    defaultMessage: 'Edit',
  },
  cartTitle: {
    id: 'CartV2.title',
    description: 'Cart title',
    defaultMessage: 'Cart',
  },
  emptyCart: {
    id: 'CartV2.emptyCart',
    description: 'Message for when the cart is empty',
    defaultMessage: 'Your cart is currently empty.',
  },
  decrementButtonMessage: {
    id: 'CartV2.decrementButton.message',
    description: 'Message for the decrement button',
    defaultMessage: 'Decrement quantity',
  },
  incrementButtonMessage: {
    id: 'CartV2.incrementButton.message',
    description: 'Message for the increment button',
    defaultMessage: 'Increment quantity',
  },
  deleteButtonMessage: {
    id: 'CartV2.deleteButton.message',
    description: 'Message for the delete button',
    defaultMessage: 'Delete Item',
  },
  continueShoppingBtnMessage: {
    id: 'CartV2.continueShoppingBtn.message',
    description: 'Message for the continue shopping button',
    defaultMessage: 'Continue Shopping',
  },
  itemsHeaderMessage: {
    id: 'CartV2.itemsHeader.message',
    description: 'Message for the items header in the line items section',
    defaultMessage: `{count, plural,
      one {1 item}
      other {{count} items}
    }`,
  },
  editUpdateBtn: {
    id: 'CartV2.editModal.editUpdateBtn',
    description: 'Label for the Update button in edit variant modal',
    defaultMessage: 'Update Cart',
  },
  editVariantTitle: {
    id: 'CartV2.editModal.editVariantTitle',
    description: 'Title for the edit variant modal',
    defaultMessage: 'Edit',
  },
  warrantyTerm: {
    id: 'CartV2.warrantyTerm',
    defaultMessage: `{count, plural,
      one {Term: 1 Year}
      other {Term: {count} Years}
    }`,
  },
  warrantyProduct: {
    id: 'CartV2.warrantyProduct',
    defaultMessage: 'Product: {product}',
  },
  creditMessage: {
    id: 'CartV2.creditMessage',
    defaultMessage: 'Instant Gift Credit with Mattress',
  },
  customerCartMergedTitle: {
    id: 'CartV2.customerCartMergedTitle',
    description:
      'Unauthenticated cart is merged with customer cart after log in',
    defaultMessage: 'You’re SIGNED In',
  },
  customerCartMergedMessage: {
    id: 'CartV2.customerCartMergedMessage',
    description:
      'Message to show when unauthenticated cart is merged with customer cart after log in',
    defaultMessage:
      'If you had different items in your cart while shopping before signing in, please double check your cart before checking out.',
  },
  incompatibleProductsWarningTitle: {
    id: 'CartV2.incompatibleProductsWarningTitle',
    description:
      'Title to show on the warning block if there are incompatible products in the cart',
    defaultMessage: 'Items in your cart are not compatible',
  },
  multipleIncompatibleRejuvenateProductsWarning: {
    id: 'CartV2.multipleIncompatibleRejuvenateProductsWarning',
    description:
      'Message to show if a product is incompatible with multiple Rejuvenate mattresses in the cart',
    defaultMessage:
      'is not compatible with the Purple Rejuvenate™ Mattress line.',
  },
  incompatibleProductsWarning: {
    id: 'CartV2.incompatibleProductsWarning',
    description:
      'Default message to use if there are incompatible products in the cart',
    defaultMessage: 'is not compatible with',
  },
  addWarrantyBtn: {
    id: 'CartV2.addWarrantyBtn',
    defaultMessage: 'Add accident protection for',
  },
  productTestUpgradeHeader: {
    id: 'CartV2.productTestUpgradeHeader:',
    description: 'Product Upgrade Test header',
    defaultMessage: 'We\'re giving you a free upgrade',
  },
  productTestUpgradeMessage1: {
    id: 'CartV2.productTestUpgradeMessage1:',
    description: 'Product Upgrade Test message 1',
    defaultMessage: 'We\'ve upgraded your twin',
  },
  productTestUpgradeMessage2: {
    id: 'CartV2.productTestUpgradeMessage2:',
    description: 'Product Upgrade Test message 2',
    defaultMessage: 'PurpleFlex Mattress',
  },
  productTestUpgradeMessage3: {
    id: 'CartV2.productTestUpgradeMessage3:',
    description: 'Product Upgrade Test message 3',
    defaultMessage: 'to our twin',
  },
  productTestUpgradeMessage4: {
    id: 'CartV2.productTestUpgradeMessage4:',
    description: 'Product Upgrade Test message 4',
    defaultMessage: 'The Purple Mattress',
  },
  productTestUpgradeMessage5: {
    id: 'CartV2.productTestUpgradeMessage5:',
    description: 'Product Upgrade Test message 5',
    defaultMessage:
      'for the same price, featuring an added Comfort Foam layer and enhanced edge support.',
  },
  productTestUpgradeDiscountMessage: {
    id: 'CartV2.productTestUpgradeDiscountMessage:',
    description: 'Product Upgrade Test discount message',
    defaultMessage: 'A discount has been applied for the difference in price',
  },
  upgradeBadge: {
    id: 'CartV2.upgradeBadge:',
    description: 'Product Upgrade Test Badge Text',
    defaultMessage: 'UPGRADED',
  },
  itemOutOfStockTitle: {
    id: 'CartV2.itemOutOfStockTitle',
    description:
      'Title to show on the info block if there are outof stock products in the cart',
    defaultMessage: 'Items in your cart are out of stock.',
  },
  itemOutOfStockInfo: {
    id: 'CartV2.itemOutOfStockInfo',
    description:
      'Message to show if there are outo of stock products in the cart',
    defaultMessage:
      '{productName} is out of stock and has been removed from your CartV2.',
  },
  conflictingPromosToasterTitle: {
    id: 'CartV2.conflictingPromosToasterTitle',
    description:
      'Title to show on the info block if there are conflicting promos',
    defaultMessage: 'Conflicting promotions',
  },
  conflictingPromosToasterDetail10OffRemoved: {
    id: 'CartV2.conflictingPromosToasterDetail10OffRemoved',
    description: 'Message to show if 10% off discount was removed',
    defaultMessage:
      'The 10% off promo was removed because it cannot stack with other promotions added.',
  },
  conflictingPromosToasterDetail10OffCannotBeApplied: {
    id: 'CartV2.conflictingPromosToasterDetail10OffCannotBeApplied',
    description: 'Message to show if 10% off discount cannot be applied',
    defaultMessage:
      'The 10% off promo could not be applied because it cannot stack with other promotions added.',
  },
  conflictingPromosToasterDetail5OffRemoved: {
    id: 'CartV2.conflictingPromosToasterDetail5OffRemoved',
    description: 'Message to show if 5% off discount was removed',
    defaultMessage:
      'The 5% off promo was removed because it cannot stack with other promotions added.',
  },
  conflictingPromosToasterDetail5OffCannotBeApplied: {
    id: 'CartV2.conflictingPromosToasterDetail5OffCannotBeApplied',
    description: 'Message to show if 5% off discount cannot be applied',
    defaultMessage:
      'The 5% off promo could not be applied because it cannot stack with other promotions added.',
  },
  lineItemFreeInHomeSetup: {
    id: 'CartV2.lineItemFreeInHomeSetup',
    description: 'Free in home setup headline for cart line item',
    defaultMessage: 'Free In-Home Setup',
  },
  fullPriceLastOfferedDate: {
    id: 'CartV2.fullPriceLastOfferedDate',
    description: 'Last offered at full price on date',
    defaultMessage: 'Last offered at full price on {fullPriceLastOfferedDate}',
  },
  customPremiumBaseIncompatibilityMessage: {
    id: 'CartV2.customPremiumBaseIncompatibilityMessage',
    description: 'Message to show if custom premium base is incompatible',
    defaultMessage: 'Rejuvenate King mattress is too heavy for a King Premium [Plus] Smart base, please select Split King for your base size.',
  },
  customHeadboardIncompatibilityMessage: {
    id: 'CartV2.customHeadboardIncompatibilityMessage',
    description: 'Message to show if headboard is incompatible with another bed frame',
    defaultMessage: 'This product is only compatible with the Upholstered Platform.',
  },
});
